import axios from 'axios';
import { ElNotification, ElMessageBox } from 'element-plus';
import sysConfig from "@/config";
import tool from '@/utils/tool';
import router from '@/router';

axios.defaults.baseURL = ''

axios.defaults.timeout = sysConfig.TIMEOUT

// HTTP request 拦截器
axios.interceptors.request.use(
	(config) => {
		config.headers['source'] = 101
		config.headers['version'] = '1.0.0'
		let token = tool.session.get("TOKEN");
		if (token) {
			config.headers[sysConfig.TOKEN_NAME] = sysConfig.TOKEN_PREFIX + token
		}
		if (!sysConfig.REQUEST_CACHE && config.method == 'get') {
			config.params = config.params || {};
			config.params['_'] = new Date().getTime();
		}
		Object.assign(config.headers, sysConfig.HEADERS)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
let codeArray = [
	500,
	90001,
	10003,
	10004,
	10006,
	10007,
	10012,
	30001,
	10013,
]
let logBack = null
// HTTP response 拦截器
axios.interceptors.response.use(
	(response) => {
		// console.log(response,999);
		
		if( response.data.msg||response.data.message){
			response.data.message = response.data.msg ? response.data.msg : response.data.message
		}
		
		if (response.data.code == 10001) {
			let strMsg = response.data.message + "<br />请联系管理员开放此接口"
			ElMessageBox.confirm(
				strMsg,
				"无权限访问",
				{
					type: "error",
					closeOnClickModal: false,
					showClose: false,
					showCancelButton: false,
					dangerouslyUseHTMLString: true,
					confirmButtonText: "确定",
				}
			)
				.then(() => {
					// router.replace({ path: "/login" });
				})
				.catch(() => { });

		} else if (response.data.code == 10002) {
			if (logBack) return false
			logBack = ElMessageBox.confirm(
				"当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。",
				"无权限访问",
				{
					type: "error",
					closeOnClickModal: false,
					showClose: false,
					showCancelButton: false,
					confirmButtonText: "重新登录",
				}
			)
				.then(() => {
					router.replace({ path: "/login" });
				})
				.catch(() => { });

		} else if (response.data.code == 10011) {
			if (logBack) return false
			logBack = ElMessageBox.confirm(
				"当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。",
				"无权限访问",
				{
					type: "error",
					closeOnClickModal: false,
					showClose: false,
					showCancelButton: false,
					confirmButtonText: "重新登录",
				}
			)
				.then(() => {
					router.replace({ path: "/login" });
				})
				.catch(() => { });

		} else if (response.data.code == 10005) {
			if (logBack) return false
			logBack = ElMessageBox.confirm(
				"当前用户已被锁定，请联系管理员后重新登陆。",
				"账号锁定",
				{
					type: "error",
					closeOnClickModal: false,
					showClose: false,
					showCancelButton: false,
					confirmButtonText: "重新登录",
				}
			)
				.then(() => {
					let url = location.href
					let route = (url).substring((url).lastIndexOf("/") + 1)
					if (route == "login") {
						window.location.reload()
					} else {
						router.replace({ path: "/login" });
					}
				})
				.catch(() => { });

		} else if (response.data.code == 10009) {
			if (logBack) return false
			logBack = ElMessageBox.confirm(
				"当前用户长时间未操作已被登出，请重新登录后再操作。",
				"登录过期",
				{
					type: "error",
					closeOnClickModal: false,
					showClose: false,
					showCancelButton: false,
					confirmButtonText: "重新登录",
				}
			)
				.then(() => {
					router.replace({ path: "/login" });
				})
				.catch(() => { });

		} else if (codeArray.indexOf(response.data.code) != -1) {
			console.log(response);
			if(response.config.url!="/mainApi/api/v1/trigger/alarm"){
				let strMsg = response.data.message
				ElMessageBox.confirm(
					strMsg,
					"请求错误",
					{
						type: "error",
						closeOnClickModal: false,
						showClose: false,
						showCancelButton: false,
						dangerouslyUseHTMLString: true,
						confirmButtonText: "确定",
					}
				)
			}
			
		}
		return response;
	},
	(error) => {
		if (error.response) {
			if (error.response.status == 404) {
				ElNotification.error({
					title: '请求错误',
					message: "Status:404，正在请求不存在的服务器记录！"
				});
			} else if (error.response.status == 500) {
				console.log(error);
				ElNotification.error({
					title: '请求错误',
					message: error.response.data.message || "Status:500，服务器发生错误！"
				});
			} else if (error.response.status == 401) {
				ElMessageBox.confirm('当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。', '无权限访问', {
					type: 'error',
					closeOnClickModal: false,
					center: true,
					confirmButtonText: '重新登录'
				}).then(() => {
					router.replace({ path: '/login' });
				}).catch(() => { })
			} else {
				ElNotification.error({
					title: '请求错误',
					message: error.message || `Status:${error.response.status}，未知错误！`
				});
			}
		} else {
			ElNotification.error({
				title: '请求错误',
				message: "请求服务器无响应！"
			});
		}

		return Promise.reject(error.response);
	}
);

var http = {

	/** get 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} params
	 * @param  {参数} config
	 */
	get: function (url, params = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'get',
				url: url,
				params: params,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** post 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	post: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** put 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	put: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'put',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** patch 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	patch: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'patch',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** delete 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	delete: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'delete',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** jsonp 请求
	 * @param  {接口地址} url
	 * @param  {JSONP回调函数名称} name
	 */
	jsonp: function (url, name = 'jsonp') {
		return new Promise((resolve) => {
			var script = document.createElement('script')
			var _id = `jsonp${Math.ceil(Math.random() * 1000000)}`
			script.id = _id
			script.type = 'text/javascript'
			script.src = url
			window[name] = (response) => {
				resolve(response)
				document.getElementsByTagName('head')[0].removeChild(script)
				try {
					delete window[name];
				} catch (e) {
					window[name] = undefined;
				}
			}
			document.getElementsByTagName('head')[0].appendChild(script)
		})
	}
}

export default http;
